/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import React, { useState } from "react";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Input,
  Image,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import signInImage from "assets/img/signInImage.png";
import logo from "assets/img/logo.png";
import { login } from "../../services/authService"; // ✅ servis
import { useUser } from "contexts/UserContext"; // ✅ User context

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const toast = useToast();
  const history = useHistory();
  const bgForm = useColorModeValue("white", "navy.800");
  const { refreshUser } = useUser(); // ✅ User context refresh için

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      // Login başarılı olduktan sonra user context'i refresh et
      await refreshUser();
      history.push("/admin/dashboard");
    } catch (err) {
      toast({
        title: "Hatalı Giriş!",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex position="relative" minH="100vh" align="center" justify="center">
      {/* Arka plan */}
      <Box
        position="absolute"
        w="100vw"
        h="100vh"
        left="0"
        top="0"
        bgImage={`url(${signInImage})`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        zIndex="0"
      >
        <Box w="100%" h="100%" bg="blue.500" opacity="0.85" />
      </Box>

      {/* Form kutusu */}
      <Flex
        zIndex="1"
        direction="column"
        w={{ base: "95vw", md: "420px" }}
        background={bgForm}
        borderRadius="2xl"
        p="40px"
        mx="auto"
        boxShadow={useColorModeValue("0px 5px 14px rgba(0, 0, 0, 0.08)", "unset")}
        align="center"
      >
        <Image
          src={logo}
          alt="Logo"
          w="200px"
          mb="40px"
          mt="-10px"
          draggable={false}
          userSelect="none"
        />

        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
          <FormControl mb="20px">
            <FormLabel htmlFor="username-input">Kullanıcı Adı</FormLabel>
            <Input
              id="username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </FormControl>

          <FormControl mb="20px">
            <FormLabel htmlFor="password-input">Şifre</FormLabel>
            <Input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </FormControl>

          <Button
            type="submit"
            fontSize="md"
            fontWeight="bold"
            w="100%"
            h="45px"
            colorScheme="blue"
          >
            Giriş Yap
          </Button>
        </form>
      </Flex>
    </Flex>
  );
}
